import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

var _this2 = this;

import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";

var isValueCodeflag = false;

var backfillHistoryData = function backfillHistoryData(_this) {
  var agentPhoneInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);

  if (!_.isEmpty(agentPhoneInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], agentPhoneInfo);
  }
};

var vueInstance = null;
var infoModel = {
  set: function set(key, val) {
    vueInstance.oppBusiData[key] = val;
  },
  get: function get(key) {
    return vueInstance.oppBusiData[key];
  }
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  _.set(fields, "VALIDATE_CODE.IS_SHOW_BUTTON", true);
  _.set(fields, "VALIDATE_CODE.FIELD_BUTTON_TXT", "获取验证码");
  _.set(fields, "VALIDATE_CODE.VALID_TYPE", "num[6]|max[6]|on_blur");
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {
    initFieldConfig(_this);
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var agentPhoneInfo, oldAgentPhoneInfo, oldAgentPhoneInfo2, tempObj;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              agentPhoneInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2]);
              oldAgentPhoneInfo = _.get(params, "" + SAVE_PATH);
              ;
              oldAgentPhoneInfo2 = _.get(params, "" + SAVE_PATH2);
              tempObj = {
                VALIDATE_RESULT: {
                  VALIDATE_CODE: agentPhoneInfo["VALIDATE_CODE"] || _this.oppBusiData.validateResult.VALIDATE_CODE,
                  MOBILE_TEL: agentPhoneInfo.MOBILE_TEL
                }
              };

              _.set(params, SAVE_PATH2, _Object$assign({}, oldAgentPhoneInfo2, tempObj));

              delete agentPhoneInfo["VALIDATE_CODE"];

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], agentPhoneInfo);
              _.set(params, SAVE_PATH, _Object$assign({}, oldAgentPhoneInfo, agentPhoneInfo));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),
  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.oppBusiData.validateCodeObj.canGoNextFlag) {
                _context2.next = 3;
                break;
              }

              _this.alert(_this.oppBusiData.validateCodeObj.MESSAGE);
              return _context2.abrupt("return", false);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {
    var agentPhoneInfo2 = _.cloneDeepGet(_this.historyData, SAVE_PATH2);
    if (!_.isEmpty(agentPhoneInfo2)) {
      _this.oppBusiData.validateResult = agentPhoneInfo2.VALIDATE_RESULT || agentPhoneInfo2.VALIDATE_CODE || {};
    }
    _this.oppBusiData.validateCodeObj = {
      canGoNextFlag: false,
      MESSAGE: "请输入正确的验证码!"
    };
    _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.MOBILE_TEL.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.AGENT_LINK_MODULE[0].FIELDS.MOBILE_TEL.DEFAULT_VALUE || "";
    if (!_.isEmpty(_this.oppBusiData.validateResult)) {
      var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

      if (fields.MOBILE_TEL.DEFAULT_VALUE != _this.oppBusiData.validateResult.MOBILE_TEL) {
        fields.VALIDATE_CODE.FIELD_CONTROL = "0";
        fields.VALIDATE_CODE.DEFAULT_VALUE = "";
        _this.oppBusiData.validateCodeObj = {
          canGoNextFlag: false,
          MESSAGE: "请输入正确的验证码!"
        };
        _this.oppBusiData.validateMsgFlag = "0";
      } else {
        fields.VALIDATE_CODE.FIELD_CONTROL = "1";

        _this.oppBusiData.validateMsgFlag = "1";
        _this.oppBusiData.validateCodeObj = {
          canGoNextFlag: true,
          MESSAGE: ""
        };
      }
    }
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},

  CHECK_VALIDATE_CODE__CLICK: function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(_this, field, fieldData) {
      var valueDataCodeRes, remainTime, interTimer;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(fieldData.MOBILE_TEL.DEFAULT_VALUE && fieldData.MOBILE_TEL.correct)) {
                _context3.next = 5;
                break;
              }

              _context3.next = 3;
              return _this.$syscfg.K_Request("F0000001", {
                APPT_SN: _this.$storage.getSession(_this.$definecfg.APPT_SN) || "",
                phoneNumber: fieldData.MOBILE_TEL.DEFAULT_VALUE
              }).catch(function (err) {
                consoleLog("获取验证码识别");
              });

            case 3:
              valueDataCodeRes = _context3.sent;

              if (valueDataCodeRes && valueDataCodeRes.Code == "0") {
                isValueCodeflag = true;
                fieldData.VALIDATE_CODE.DEFAULT_VALUE = _.get(valueDataCodeRes, "Data[0].code", "");
                _this.alert("验证码已发送到：【" + fieldData.MOBILE_TEL.DEFAULT_VALUE + "】，请注意查收！");

                _this.$set(field, "BUTTON_ENABLE", true);
                remainTime = parseInt(_this.oppBusiData.busiCommonParams.MOBILE_VALID_TIME) || 120, interTimer = setInterval(function () {
                  remainTime--;
                  _this.$set(field, "FIELD_BUTTON_TXT", remainTime + "\u79D2\u540E\u91CD\u65B0\u83B7\u53D6");
                }, 1000);

                _this.oppBusiData.interTimer = interTimer;
                _this.oppBusiData.validateMsgFlag = "0";

                _this.oppBusiData.isAssignValidCodeTimeout = true;
                setTimeout(function () {
                  _this.oppBusiData.isAssignValidCodeTimeout = false;
                  _this.$set(field, "BUTTON_ENABLE", false);
                  _this.$set(field, "FIELD_BUTTON_TXT", "获取验证码");
                  clearInterval(interTimer);
                }, remainTime * 1000);
              }

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    return function CHECK_VALIDATE_CODE__CLICK(_x5, _x6, _x7) {
      return _ref3.apply(this, arguments);
    };
  }(),

  CHECK_VALIDATE_CODE: function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4(_this, field, fieldData) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(fieldData.VALIDATE_CODE.DEFAULT_VALUE && isValueCodeflag && _this.oppBusiData.validateMsgFlag == "0")) {
                _context4.next = 5;
                break;
              }

              _this.oppBusiData.validateCodeObj = {
                canGoNextFlag: false,
                MESSAGE: ""
              };
              _this.myLoading({
                loadingText: "正在校验验证码...",
                autoHide: false
              });
              _context4.next = 5;
              return _this.$syscfg.K_Request("F0000024", {
                phoneNumber: fieldData.MOBILE_TEL.DEFAULT_VALUE,
                code: field.DEFAULT_VALUE
              }).then(function (res) {
                _this.oppBusiData.validateMsgFlag = "1";
                _this.oppBusiData.validateCodeObj.canGoNextFlag = true;
                _this.oppBusiData.validateCodeObj.MESSAGE = "";
              }).catch(function (err) {
                _this.alert(err);
                _this.oppBusiData.validateCodeObj.MESSAGE = err;
              }).finally(function () {
                _this.myLoading({ showLoading: false });
              });

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));

    return function CHECK_VALIDATE_CODE(_x8, _x9, _x10) {
      return _ref4.apply(this, arguments);
    };
  }()
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizPassword/bizAgentPhoneInfoNode.js
// module id = 167
// module chunks = 2